module.exports = __webpack_public_path__ + "img/fb@2x.384e1c4b.svg";